"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRedirectionIntermediary = void 0;
const createRedirectionIntermediary = ({ redirectTo: redirectOnSignInComplete, }) => createHTML(redirectOnSignInComplete);
exports.createRedirectionIntermediary = createRedirectionIntermediary;
// This HTML does the following:
// 1. redirect to `redirectTarget` using JavaScript on page load
// 2. redirect to `redirectTarget` relying on the meta tag if JavaScript is disabled
// 3. display a link to `redirectTarget` if the redirect does not happen
const createHTML = (redirectTarget) => `
<!DOCTYPE html>
	<html>
	<head>
			<title>Redirecting...</title>
			<meta http-equiv="refresh" content="0; URL='${redirectTarget}'" />
			<script>window.location.replace("${redirectTarget}")</script>
	</head>
	<body>
			<p>If you are not redirected automatically, follow this <a href="${redirectTarget}">link to the new page</a>.</p>
	</body>
</html>`;
